import React from 'react';
import { useLocalization } from '../../../localization'; // Added import

const SupportPage = () => {
  const { t } = useLocalization(); // Added hook call

    return (
      <div className="columns my-3">
        <div className="column col-4 col-mx-auto">
          <h1>{t('support.title')}</h1> {/* Localized */}
          {t('support.instructions_placeholder')} {/* Localized */}

      </div>
      </div>
    );
};

export default SupportPage;